import { render, staticRenderFns } from "./selfie.vue?vue&type=template&id=005e104c&scoped=true"
import script from "./selfie.vue?vue&type=script&lang=js"
export * from "./selfie.vue?vue&type=script&lang=js"
import style0 from "./selfie.vue?vue&type=style&index=0&id=005e104c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e104c",
  null
  
)

export default component.exports